// extracted by mini-css-extract-plugin
export var closeButton = "_k6-2";
export var closeButtonIcon = "_k6-3";
export var lightboxContent = "_k6-1";
export var lightboxOverlay = "_k6-0";